var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 10.5h360c5 0 9 4 9 9v119c0 5-4 9-9 9H20c-5 0-9-4-9-9v-119c0-5 4-9 9-9zM20 0h360c11 0 20 9 20 20v118c0 11-9 20-20 20H20c-11 0-20-9-20-20V20C0 9 9 0 20 0zm0 5A15 15 0 0 0 5 20v118a15 15 0 0 0 15 15h360a15 15 0 0 0 15-15V20a15 15 0 0 0-15-15H20z",
  fill: "#0460CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M284 74.2h16v55.5h-28l12-55.5zm28.8 0h15.7l11 55.5h-26.7V74.2zm-64.2-13.6h115.2v6.7h-13v15.3h-7.3l-4-15.3H271l-3.8 15.3h-7.5V67.3h-11.2v-6.7zM287 53l5-25.3h9v25.3h-14zm39 0h-14V27.8h9l5 25.3z",
  fill: "#FFF"
}))));
export { SvgSign as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/sign.svg", import.meta.url).toString();